export default "__VITE_ASSET__Cwkyszo2__"